// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"32":"misc","328":"admin","601":"work","676":"message","809":"account","983":"report"}[chunkId] || chunkId) + "." + {"32":"28473011","151":"2ca709cb","226":"981b3f81","328":"3902c874","601":"56b0b7e7","665":"00d6f82d","676":"a40d6dc7","809":"7c315a8e","983":"9c89d789"}[chunkId] + ".js";
};